import type { IconProps } from './types';

/** LIVENODE のシンボルロゴ（LN_SM_202606）。ブランドカラーは #0BF480。 */
export const IconLivenodeLogo = ({ width, height, color = '#0BF480', className }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.936 0.109333C20.812 0.0133333 21.7413 0.248 22.6347 0.398667C23.528 0.556 24.3973 0.888 25.2853 1.02667C26.1787 1.16533 27.096 1.268 27.9907 1.22533C28.8907 1.18267 29.784 0.953333 30.672 0.784C31.5653 0.614667 32.4413 0.277333 33.3347 0.198667C34.228 0.114667 35.1947 0.06 36.0333 0.301333C36.872 0.537333 37.7667 1.008 38.364 1.624C38.956 2.24533 39.4387 3.164 39.596 4.00267C39.7533 4.84133 39.632 5.868 39.3 6.65333C38.968 7.444 38.3213 8.23467 37.616 8.73067C36.9093 9.22533 35.9493 9.52133 35.08 9.61867C34.204 9.72133 33.2747 9.48533 32.3867 9.33467C31.4933 9.184 30.624 8.85733 29.7307 8.71867C28.8373 8.58533 27.9253 8.48933 27.0253 8.52533C26.1253 8.568 25.232 8.79067 24.344 8.96C23.4507 9.12933 22.5747 9.46667 21.6813 9.552C20.788 9.63067 19.8213 9.69067 18.9827 9.44933C18.144 9.21333 17.244 8.73733 16.652 8.12133C16.0547 7.5 15.5653 6.58133 15.408 5.74267C15.2453 4.89733 15.36 3.87067 15.692 3.08C16.024 2.28933 16.6827 1.492 17.388 0.997333C18.0947 0.502667 19.06 0.212 19.936 0.109333Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.35867 15.3293C5.22267 15.2333 6.26 15.468 7.04 15.8733C7.81333 16.284 8.568 17.02 8.996 17.7867C9.43067 18.548 9.588 19.556 9.62933 20.456C9.672 21.356 9.40533 22.2853 9.23733 23.1973C9.068 24.1027 8.724 24.9907 8.628 25.9027C8.532 26.8147 8.392 27.8347 8.65867 28.6613C8.924 29.4827 9.52267 30.3947 10.228 30.8467C10.9347 31.3053 11.9973 31.372 12.8973 31.3907C13.7973 31.4093 14.7213 31.1253 15.6267 30.956C16.5387 30.7867 17.432 30.4547 18.344 30.3827C19.256 30.304 20.2453 30.244 21.0907 30.5093C21.936 30.7747 22.824 31.312 23.4027 31.9707C23.9827 32.6227 24.4347 33.5827 24.556 34.4467C24.6707 35.304 24.5013 36.36 24.1093 37.1333C23.7227 37.9067 22.968 38.6373 22.2133 39.084C21.4587 39.5307 20.4747 39.76 19.5747 39.8147C18.6813 39.8747 17.7453 39.5907 16.84 39.428C15.928 39.2587 15.0413 38.9213 14.1293 38.812C13.2173 38.6973 12.2813 38.6733 11.364 38.752C10.452 38.8307 9.55333 39.108 8.64667 39.2773C7.73467 39.452 6.82933 39.7667 5.924 39.7907C5.012 39.8093 4.016 39.7547 3.20133 39.4107C2.392 39.0667 1.56533 38.432 1.05733 37.72C0.544 37.008 0.248 36.024 0.14 35.1293C0.0306667 34.2413 0.254667 33.2933 0.4 32.3827C0.550667 31.4773 0.894667 30.5893 1.03333 29.6773C1.16667 28.772 1.26267 27.836 1.22 26.924C1.17733 26.0067 0.942667 25.0947 0.766667 24.1893C0.592 23.284 0.236 22.3907 0.169333 21.4787C0.102667 20.5733 0.0786667 19.5707 0.356 18.732C0.64 17.8933 1.19467 17.0173 1.86 16.4493C2.53067 15.8813 3.496 15.4293 4.36 15.332L4.35867 15.3293Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.90267 0C7.612 0 9.812 2.19333 9.812 4.90267C9.812 7.612 7.612 9.812 4.90267 9.812C2.19333 9.812 0 7.612 0 4.90267C0 2.19333 2.19333 0 4.90267 0Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.9973 15.0947C22.7067 15.0947 24.9067 17.288 24.9067 19.9973C24.9067 22.7067 22.7067 24.9067 19.9973 24.9067C17.288 24.9067 15.0947 22.7067 15.0947 19.9973C15.0947 17.288 17.288 15.0947 19.9973 15.0947Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.0907 15.0947C37.8 15.0947 40 17.288 40 19.9973C40 22.7067 37.8 24.9067 35.0907 24.9067C32.3813 24.9067 30.188 22.7067 30.188 19.9973C30.188 17.288 32.3813 15.0947 35.0907 15.0947Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.0907 30.1893C37.8 30.1893 40 32.3827 40 35.092C40 37.8013 37.8 40.0013 35.0907 40.0013C32.3813 40.0013 30.188 37.8013 30.188 35.092C30.188 32.3827 32.3813 30.1893 35.0907 30.1893Z'
        fill={color}
      />
    </svg>
  );
};
